import { useState } from 'react';

import { SparksAgentService } from './services/SparksAgentService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { SparksActionButton } from './SparksActionButton';
import { SparksContextBlock } from './SparksContextBlock';

const DISPLAY_EMOJIS = ['🧑‍🔬', '🔍', '🕵️‍♂️'];

type SparksWelcomeProps = {
    onActionClick: (text: string) => void;
};

export function SparksWelcome({ onActionClick }: SparksWelcomeProps) {
    const { t } = useTranslation('sparks');
    const [questions] = useState(() => SparksAgentService.getQuickQuestions());

    return (
        <div className="flex flex-1 flex-col justify-end gap-4 overflow-hidden px-3.5 pb-4 pt-6">
            <div className="flex flex-col gap-3 px-1.5">
                <SparksContextBlock />
                <h2 className="font-PNineties text-[32px] font-normal leading-[32px] tracking-[0.5px] text-icoBlack dark:text-white">
                    {t('welcome_title_start')}
                    <em className="italic tracking-[-0.5px]">{t('welcome_title_end')}</em>?
                </h2>
            </div>
            <div className="flex flex-col gap-1.5">
                {questions.map((question, index) => (
                    <SparksActionButton
                        key={question.id}
                        label={`${DISPLAY_EMOJIS[index]} ${t(question.translationKey)}`}
                        onClick={() => onActionClick(t(question.translationKey))}
                    />
                ))}
            </div>
        </div>
    );
}
